<template>
  <card titulo="Atos Registrados">

    <template #acoes>
      <v-button v-if="atribuicao && !$root.isAuditorOnly" :run="imprimirAtos" :button="false" :popover="true" :params="[atribuicao]"
                position="dropleft" class="icon float-right ml-2" :title="`Imprimir Atos ${atribuicao.toUpperCase()}`">
        <i class="fal fa-print"></i>
      </v-button>
    </template>

    <v-input type="radio" :options="atribuicoes" v-model="atribuicao"/>

    <template v-if="atribuicao">
      <async-table :key="atribuicao" :columns="colunas" :pagination="buscar"
                   class="table table-card w-100"
                   name="atos-indicador-pessoal">
        <template #row="{ row }">
          <tr>
            <td>
              <a href class="mb-1 pointer" @click.prevent="verFicha(row.ficha)">
                {{getFicha(row.ficha)}}
              </a>
              <div class="w-100 mt-1 small text-muted">
                <resumo-indicador-real :imovel="row.ficha" />
              </div>
            </td>
            <td style="min-width: 300px">
              <a class="icon" @click.prevent="verAto(row)">
                {{getCodigo(row, row.ficha)}}
                <template v-if="row.titulo">- {{row.titulo}}</template>
                <template v-else-if="row.tipoServico && row.tipoServico.opcoes && row.tipoServico.opcoes.titulo">
                  - {{row.tipoServico.opcoes.titulo}}
                </template>
              </a>
              <div class="w-100 mt-1 small text-muted">
                <template v-if="row.protocoloCodigo">
                  <router-link :to="{ name: 'protocolo', params:{id : row.protocoloId} }" class="mb-1 pointer" target="_blank" @click.native="$event.stopImmediatePropagation()">
                    {{ nomearProtocolo(row.protocoloDominio, row.tipoProtocolo, row.protocoloCodigo) }}
                  </router-link>
                </template>
                <span class="text-muted"> {{$formatters.date(row.registro)}}</span>
                <v-button :button="false" class="icon ml-2" :class="{'text-success': row.validacao}" :title="row.validacao ? 'Ato Validado' : 'Aguardando Validação'">
                  <i class="fal fa-check-double"></i>
                </v-button>
              </div>
            </td>
            <td style="min-width: 160px">{{ getPapel(row.papel) }}</td>
            <td v-if="atribuicao === 'rtd' || atribuicao === 'rcpj'"
                class="text-truncate"
                style="max-width: 300px"
                :title="stripHtml(row.texto)">
              {{ stripHtml(row.texto) }}
            </td>
          </tr>
        </template>

        <template #empty>
          <tr>
            <td colspan="100%">
              <div class="alert alert-outline-info">Não há atos para exibir</div>
            </td>
          </tr>
        </template>
      </async-table>

      <async-pager name="atos-indicador-pessoal"/>
    </template>

  </card>
</template>

<script>
  import FrontBusiness from "@/business/FrontBusiness";
  import IndicadorBusiness from "@/business/indicadores/IndicadorBusiness.js";
  import IndicadorPessoalBusiness from "@/business/indicadores/IndicadorPessoalBusiness";
  import { tratarAto } from "@/business/indicadores/IndicadorPessoalBusiness";
  import RelatorioBusiness from "@/business/RelatorioBusiness";
  import AtoBusiness from "@/business/protocolo/AtoBusiness.js";
  import Card from "@/components/Layout/components/Card.vue";
  import AsyncTable from "@/components/Table/AsyncTable.vue";
  import AsyncPager from "@/components/Table/AsyncPager.vue";
  import DetalhesAtoRegistrado from "@/components/IndicadorGeneric/Detalhes/DetalhesAtoRegistrado.vue";
  import ResumoIndicadorReal from "@/components/IndicadorReal/ResumoIndicadorReal";
  import businessTipoServico from "@/views/Administracao/modulos/tipo-servico/business";

  export default {

    name: "Atos",
    components: {ResumoIndicadorReal, AsyncTable, AsyncPager, Card},
    props: {
      pessoa: Object
    },

    data() {
      return {
        atribuicao: null
      }
    },

    computed: {

      atribuicoes() {
        let atribuicoes = [];
        if(this.$root.isRI){
          atribuicoes.push({id: 'ri', nome: 'RI'});
        }
        if(this.$root.isRTD){
          atribuicoes.push({id: 'rtd', nome: 'RTD'});
        }
        if(this.$root.isRCPJ){
          atribuicoes.push({id: 'rcpj', nome: 'RCPJ'});
        }
        if(this.$root.atribuicaoAtiva('NOTAS')){
          atribuicoes.push({id: 'tn', nome: 'TN'});
        }
        return atribuicoes;
      },

      colunas() {
        let cols = [
          { label: 'Ficha', field: 'v.codigo_indicador' },
          { label: 'Ato', field: 'a.registro' },
          { label: 'Papel', field: null }
        ];
        if (this.atribuicao === 'rtd' || this.atribuicao === 'rcpj') {
          cols.push({ label: 'Minuta', field: null });
        }
        return cols;
      }
    },

    mounted() {
      this.atribuicao = this.atribuicoes[0].id;
    },

    methods: {
      getPapel(papel){ return businessTipoServico.nomePapel(papel) },
      stripHtml(html) {
        if (!html) return '';
        return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
      },
      getCodigo: AtoBusiness.getCodigo,
      getFicha: FrontBusiness.nomearFicha,

      async buscar(sortBy, sortDir, perPage, page) {
        let result = await IndicadorPessoalBusiness.buscarAtosRegistradosPaginado(
          this.pessoa.indicadorPessoalId, this.atribuicao, sortBy, sortDir, page, perPage
        );
        return {
          rows: result.pagina?.map(tratarAto),
          total: result.quantidade
        };
      },

      nomearProtocolo(dominio, tipoProtocolo, codigo){
        return FrontBusiness.nomearProtocolo(dominio, tipoProtocolo, codigo);
      },

      async verAto(ato) {
        FrontBusiness.openModal(DetalhesAtoRegistrado, {item: ato, ficha: ato.ficha});
      },

      verFicha(ficha) {
        FrontBusiness.openModal(IndicadorBusiness.getDetalhesIndicador(ficha.livro), {id: ficha.id});
      },

      async imprimirAtos(atribuicao) {
        let url = `api/relatorio/relatorio-atos-indicador-real/${atribuicao}/${this.pessoa.id}`
        await RelatorioBusiness.visualizarPdf(url, "Relatório")
      }
    }
  }
</script>
